import { Label, Radio, TextArea } from '@iwoca/orion';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { FieldError } from '../../FieldError/FieldError';
import sharedStyles from '../../RegistrationForm.module.css';
import { TRegistrationFormValues } from '../../registrationForm.types';
import styles from './CommercialFinance.module.css';

export const CommercialFinance = () => {
  const {
    register,
    watch,
    setValue,
    trigger,
    formState: { isSubmitted, errors },
  } = useFormContext<TRegistrationFormValues>();
  const isCommercialFinance = watch('primarilyCommercialFinance');

  const handleYesClick = () => {
    setValue('primarilyCommercialFinance', 'true');
    setValue('businessProvision', '');

    if (isSubmitted) {
      trigger();
    }
  };

  return (
    <div className={styles.radioOptionsContainer}>
      <div className={clsx(sharedStyles.formField)}>
        <Label>
          Does your business primarily work in commercial finance brokering?
        </Label>
        <div className={styles.radioOptions}>
          <Radio
            {...register('primarilyCommercialFinance')}
            wrapperClassName={styles.radio}
            value="true"
            label="Yes"
            data-testid="commercial-finance-yes"
            onChange={handleYesClick}
          />
          <Radio
            {...register('primarilyCommercialFinance')}
            wrapperClassName={styles.radio}
            className={styles.radio}
            value="false"
            data-testid="commercial-finance-no"
            label="No"
          />
        </div>
        <FieldError
          errorMessage={errors?.primarilyCommercialFinance?.message}
        />
      </div>

      {isCommercialFinance === 'false' && (
        <div className={sharedStyles.formField}>
          <Label>What kind of finance does your business provide?</Label>
          <p className={sharedStyles.instruction}>
            Please list all types of finance.
          </p>
          <TextArea
            {...register('businessProvision')}
            className={styles.textArea}
          />
          <FieldError errorMessage={errors?.businessProvision?.message} />
        </div>
      )}
    </div>
  );
};
